import React from 'react'
import styles from '../Proj2Folder/Proj2.module.css'
import sheraton from '../../Images/sheraton.jpg'
import goldens from '../../Images/goldens.jpg'
import ksa from '../../Images/ksa.jpg'
import nasser from '../../Images/nasser.jpg'
import nasserOffice from '../../Images/nasserOffice.jpg'
import { Link } from 'react-router-dom'
import AOS from "aos";
import 'aos/dist/aos.css'
import { useEffect } from 'react'

export default function Proj2() {
  useEffect(() => {
    AOS.init({duration: 1500})
  
  }, [])
  return (

    <>
       <section className='my-5 py-3 '>
       <div  className={`${styles.bgCard} container my-5 py-5 `}>
        
        <h2 className='text-center fs-2 fw-bolder position-relative mainColor'>  Residential & Administrative Buildings
        
        <div className="shortline mt-2"></div>
        <div className="longline"></div>
        <div className="shortline mb-2"></div>
        </h2>
        <div className="row">
        <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
           
         <Link to="/sheraton" className={`${styles.linkPro}`}> 
         <img src={sheraton} alt="achegy" className={`${styles.imgSizeProj}`}/>
         <p className='text-center fw-bold mt-3'>Sheraton Building</p>
         </Link>  
          </div>
          <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
              <Link to="/golden" className={`${styles.linkPro}`}> 
            <img src={goldens} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>Golden Pyramids </p>
             </Link> 
          </div>
          <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
             <Link to="/ksa" className={`${styles.linkPro}`}> 
            <img src={ksa} alt="achegy" className={`${styles.imgSizeProj}`}/>
            <p className='text-center fw-bold mt-3'>AL HIJRAH RESIDENTIAL & COMMERCIAL</p>
             </Link> 
         
          </div>
          <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
         <Link to="/nasser" className={`${styles.linkPro}`}> 
         <img src={nasser} alt="achegy" className={`${styles.imgSizeProj}`}/>
         <p className='text-center fw-bold mt-3'>Nasser Rashed Residential Tower, Qatar </p>
         </Link>  
          </div>
          <div className="col-md-4 my-3 text-center" data-aos='fade-up'>
         <Link to="/nasserOffice" className={`${styles.linkPro}`}> 
         <img src={nasserOffice} alt="achegy" className={`${styles.imgSizeProj}`}/>
         <p className='text-center fw-bold mt-3'>Nasser Rashed Office Tower, Qatar </p>
         </Link>  
          </div>

     
        </div>
       </div>
       
    </section>

    
    </>
   
  )
}
